import React, { useContext } from 'react'
import { Box } from '@mui/material'
import PropTypes, { object, array } from 'prop-types'
import { heightFooterSticky } from '../../constants'
import { ThemeContext } from '~/theme/ThemeProvider'

const FooterSticky = ({ children }) => {
  const { currentThemeObject } = useContext(ThemeContext)
  return (
    <Box
      borderTop={`1px ${currentThemeObject.colorText1 || 'red'} solid`}
      display="flex"
      justifyContent="center"
      alignItems="center"
      position="fixed"
      bottom={0}
      left={0}
      right={0}
      minHeight={heightFooterSticky}
      bgcolor={'baseColor.color1'}
      paddingY="10px">
      {children}
    </Box>
  )
}

export default React.memo(FooterSticky)

FooterSticky.propTypes = {
  children: PropTypes.oneOfType([object, array]),
}
